import { Button as ButtonAntd, ButtonProps } from "antd";
import { useCallback, useState } from "react";
import styled from "styled-components";

interface Props extends Omit<ButtonProps, "style"> {
  outline?: boolean;
  colorText?: string;
  width?: string;
  bgColor?: string;
  border?: string;
  height?: string;
  fontSize?: string | number;
  onClick?: () => Promise<void> | void;
}

const Button: React.FC<Props> = ({
  outline = false,
  colorText = "#fff",
  width = "200px",
  bgColor = "#5E1DBB",
  border = "none",
  height = "30px",
  fontSize = "16px",
  className,
  children,
  onClick,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (!onClick) return;
    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  }, [onClick]);

  return (
    <StyledButton
      $colorText={colorText}
      $width={width}
      $bgColor={bgColor}
      $border={border}
      $height={height}
      $fontSize={fontSize}
      onClick={handleClick}
      loading={isLoading}
      $outline={outline}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled(ButtonAntd)<{
  $colorText: string;
  $width: string;
  $bgColor: string;
  $border: string;
  $height: string;
  $fontSize: string | number;
  $outline?: boolean;
}>`
  height: ${(props) => props.$height};
  width: ${(props) => props.$width};
  color: ${(props) => props.$colorText} !important;
  background-color: ${({ $bgColor, $outline }) =>
    $outline ? "transparent" : $bgColor} !important;
  border: ${(props) => props.$border};
  font-size: ${(props) => props.$fontSize};
  border-radius: 5px;
  cursor: pointer;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.6;
  }
`;
